/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersOrderIdGiveMutationResponse, PostOrdersOrderIdGivePathParams, PostOrdersOrderIdGive400 } from "../entities/PostOrdersOrderIdGive";

function getPostOrdersOrderIdGiveUrl(order_id: PostOrdersOrderIdGivePathParams["order_id"]) {
  const res = { method: 'POST', url: `/orders/${order_id}/give` as const }  
  return res
}

/**
 * @description Ручка "Передал посылку курьеру"
 * @summary Ручка "Передал посылку курьеру"
 * {@link /orders/:order_id/give}
 */
export async function postOrdersOrderIdGive(order_id: PostOrdersOrderIdGivePathParams["order_id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PostOrdersOrderIdGiveMutationResponse, ResponseErrorConfig<PostOrdersOrderIdGive400>, unknown>({ method : "POST", url : getPostOrdersOrderIdGiveUrl(order_id).url.toString(), ... requestConfig })  
  return res.data
}